var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event px40",staticStyle:{"padding-top":"20px"}},[_c('a',{staticClass:"pointer",staticStyle:{"padding-left":"calc(10% + 40px)"},on:{"click":function($event){return _vm.$router.push('/events')}}},[_vm._v("Back to Events")]),(_vm.active)?_c('quiz-campaign',{attrs:{"campaign":_vm.active,"showImages":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }